import { jsx as _jsx } from "react/jsx-runtime";
import { _keys, filterInstances, isErrorOfType, ValidationException } from '@nu-art/ts-common';
export const isDependencyError = (e) => {
    return (e.errorResponse?.error.type === 'has-dependencies');
};
export const generateErrorToastContent = (e, content, additionalData) => {
    //
    // if (isDependencyError(e)) {
    // 	return <ResolveDependencyToast dependencyConflicts={e.errorResponse.error.data} deletedEntity={additionalData}/>;
    // }
    if (isErrorOfType(e, ValidationException))
        return _jsx("div", { children: `Invalid input for fields: ${filterInstances(_keys(e.result)).join(', ')}` });
    return _jsx("div", { children: "Something went wrong, try again later..." });
};
//# sourceMappingURL=genereteToasts.js.map